import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  //esim列表
  {
    path: '/products/esim',
    name: 'ESIM',
    component: () => import('@/views/products/ESIM.vue')
  },
  //sim列表页
  {
    path: '/products/sim',
    name: 'SIM',
    component: () => import('@/views/products/SIM.vue')
  },
  {
    path: '/products/detail',
    name: 'ProductDetail',
    component: () => import('@/views/products/detail/esimProductDetail.vue')
  },
  //主页home 区域产品
  {
    path: '/products/groupProductList',
    name: 'GroupProductList',
    component: () => import('@/views/products/detail/groupProductList.vue'),
    meta: {
      activeMenu: '/products/esim' 
    }
  },
  //sim卡列表
  {
    path: '/products/sim/groupProductList',
    name: 'SimGroupProductList',
    component: () => import('@/views/products/detail/simGroupProductList.vue'),
    meta: {
      activeMenu: '/products/sim' 
    }
  },
  //订单支付
  {
    path: '/order/simOrder',
    name: 'SimOrder',
    component: () => import('@/views/order/simOrder.vue'),
    meta: {
      activeMenu: '/products/sim' 
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/cart/Cart.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/user/User.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/user/Orders.vue')
      },
      {
        path: 'orderDetail',
        name: 'OrderDetail',
        component: () => import('@/views/user/OrderDetail.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/user/Profile.vue')
      },
      {
        path: 'productBuy',
        name: 'ProductBuy',
        component: () => import('@/views/user/ProductBuy.vue')
      }
    ]
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/views/support/Support.vue'),
    children: [
      {
        path: 'faq',
        name: 'FAQ',
        component: () => import('@/views/support/FAQ.vue')
      },
      
      {
        path: 'how-to-work',
        name: 'HowToWork',
        component: () => import('@/views/support/HowToWork.vue')
      },
      {
        path: 'track',
        name: 'Track',
        component: () => import('@/views/support/Track.vue')
      }
    ]
  },
  {
    path: '/support/return',
    name: 'Return',
    component: () => import('@/views/support/Return.vue')
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('@/views/business/Business.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters.isAuthenticated

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router 